import { onMount } from "solid-js";
import { supabase, takePostAuthRedirect } from "~/lib/supabase";

import { createFileRoute, useNavigate } from "@tanstack/solid-router";

export const Route = createFileRoute("/auth/callback")({
  component: AuthCallback,
});

function AuthCallback() {
  const navigate = useNavigate();

  onMount(async () => {
    // Supabase handles the OAuth code exchange automatically via onAuthStateChange
    // Just wait briefly then redirect. A caller that re-ran login for a reason
    // (e.g. "Import from Xbox") may have stashed where to return to.
    await supabase.auth.getSession();
    navigate({ to: takePostAuthRedirect() ?? "/dashboard", replace: true });
  });

  return (
    <div class="flex items-center justify-center min-h-screen">
      <div class="text-center space-y-3">
        <div class="w-8 h-8 border-2 border-brand border-t-transparent rounded-full animate-spin mx-auto" />
        <p class="text-text-muted text-sm">Signing you in...</p>
      </div>
    </div>
  );
}
